/**
 * F2F: twee fanberichten vlak na elkaar (30-10-2026, Jordy; fan T84T op NT).
 *
 * De F2F-chatlijst geeft per gesprek alleen het LAATSTE bericht. Stuurt een fan
 * er twee tussen twee pollrondes (~3 min), dan ziet de poller alleen het tweede.
 * Het eerste komt pas binnen met het volledig ophalen, en dat doet de poller
 * bewust niet zolang de chat ongelezen is (F2F laat de fan dan "gelezen" zien).
 * Gemeten: de chatter antwoordde om 08:56 zonder het bericht van 08:55:07 te
 * zien; het kwam om 08:58 binnen, ná het antwoord.
 *
 * Het chatscherm zelf slaat niets over: het haalt elke 1,2 s het hele venster
 * opnieuw op, gesorteerd op tijdstip. Wat ontbreekt, staat nog niet in de
 * database.
 *
 * Daarom: staat er een F2F-chat open waarvan het nieuwste bericht een
 * onbeantwoord fanbericht is, dan vragen we het volledige gesprek op
 * (f2f-full-fetch; de worker haalt het op).
 *
 * 31-10-2026 (Jordy): de fan ziet dan "gelezen". Dat mag alleen als een chatter
 * het gesprek actief opent om te antwoorden (zie `magStaartVragen`), één keer
 * per fanbericht-burst per gesprek, met een limiet per gesprek en per minuut.
 * De server (`_f2f_volledig_weigering`) dwingt hetzelfde af.
 */

/**
 * Opent deze gebruiker het gesprek om te antwoorden? Alleen een chatter (rol
 * chatter, dus ook head chatter) van wie het gesprek nu is: geclaimd door openen
 * of door zijn antwoord (`inbox-open` geeft 'mine'), of privé aan hem toegewezen.
 * Owner, admin en manager bekijken zonder te claimen ('view'), een viewer
 * antwoordt niet, en bij een ander ('other') kijk je alleen mee.
 */
export function magStaartVragen(
  rol: string | null | undefined,
  inboxStand: string | null | undefined,
  priveAanMij: boolean,
): boolean {
  if (String(rol ?? '').toLowerCase() !== 'chatter') return false
  return inboxStand === 'mine' || priveAanMij
}

/** 30-10-2026 (Jordy, limiet): per gesprek hooguit één volledige ophaling per
 *  minuut, hoeveel fanberichten er ook binnenkomen. Daarbovenop zet de server
 *  per gesprek hooguit één open opdracht klaar (media_fetch) en verwerkt de
 *  worker er hooguit 10 per ronde. */
export const STAART_RUST_MS = 60_000

/** Mag er nu een ophaling voor dit gesprek? `vorige` = tijdstip van de vorige. */
export function staartMagNu(vorige: number | undefined, nu: number): boolean {
  return vorige == null || nu - vorige >= STAART_RUST_MS
}

export interface StaartBericht {
  id: number
  sender: string
  event_type?: string | null
}

/**
 * De sleutel van het onbeantwoorde nieuwste fanbericht, of null als er niets
 * te vragen is (geen F2F, of het laatste bericht is van ons). `berichten` staat
 * van oud naar nieuw, zoals de server ze geeft. Regels zonder eigen bericht
 * (event_type, zoals een ontgrendeling) tellen niet mee.
 */
export function staartSleutel(
  platform: string | null | undefined,
  berichten: readonly StaartBericht[],
): string | null {
  if (platform !== 'f2f') return null
  let laatste: StaartBericht | null = null
  for (const m of berichten) if (!m.event_type) laatste = m
  if (!laatste || String(laatste.sender).toLowerCase() !== 'fan') return null
  return String(laatste.id)
}
